import { render, staticRenderFns } from "./emptyModule.vue?vue&type=template&id=3652b061"
import script from "./emptyModule.vue?vue&type=script&lang=js"
export * from "./emptyModule.vue?vue&type=script&lang=js"
import style0 from "./emptyModule.vue?vue&type=style&index=0&id=3652b061&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports